import { MutableRefObject, createContext } from 'react';
import { RowFormProps } from '../interface';
import { dispatchFunc } from '../hook/useEditSubTablehook';

export interface IBaseEditSubTableContext {
  tableDataSource?: any[];
  forms?: MutableRefObject<RowFormProps[]>;
  expandedRowKeys?: string[];
  editableRef?: HTMLDivElement;
  showAddSubRow?: boolean;
  showEmptySubRow?: boolean;
}
export interface IEdiTableContext extends IBaseEditSubTableContext {
  dispatchEditSubTable: dispatchFunc;
}
export default createContext<IEdiTableContext>({
  dispatchEditSubTable: () => {},
});